module.exports = __webpack_public_path__ + "img/mao-na-lampada.f4d6b95b.svg";